import { NextPage } from 'next';
import { Dispatch, SetStateAction, useEffect, useState } from 'react';

interface Props {
  items: any[];
  searchTerm?: string;
  selectedItem: any;
  selectedValue: any;
  setSelectedItem: Dispatch<SetStateAction<any>>;
}

const ListCheckBox: NextPage<Props> = ({
  items,
  searchTerm = '',
  selectedItem,
  selectedValue,
  setSelectedItem,
}) => {
  const filteredItems = items.filter((item: any) =>
    item.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleRadioChange = (id: string) => {
    setSelectedItem(id);
  };

  useEffect(() => {
    if (selectedValue) {
      setSelectedItem(selectedValue);
    }
  }, [selectedValue]);

  return (
    <>
      <ul className="rounded p-4 h-[calc(100vh-170px)] overflow-y-auto">
        {(searchTerm?.length >= 3 ? filteredItems : items).map((item: any) => (
          <li key={item.id}>
            <button
              type="button"
              className="flex items-center gap-[18px] mb-2 h-12 w-full"
              onClick={() => {
                handleRadioChange(item.id);
              }}
            >
              <input
                type="radio"
                name="items"
                checked={selectedItem === item.id}
                onChange={() => handleRadioChange(item.id)}
                className="w-4 h-4 border-gray-300 text-red-500 focus:ring-red-500 cursor-pointer accent-supportiveRed dark:ring-offset-gray-800 focus:ring-0 dark:bg-gray-700 dark:border-gray-600"
              />
              <label>{item.name}</label>
            </button>
          </li>
        ))}
      </ul>
    </>
  );
};

export default ListCheckBox;
